import { Component } from '@angular/core';

@Component({
  selector: 'app-eye-slash-icon',
  templateUrl: './eye-slash-icon.component.html',
  styleUrl: './eye-slash-icon.component.scss'
})
export class EyeSlashIconComponent {

}
